export default __webpack_public_path__ + "static/media/ic_star_grey.9f9095e9.svg";